import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../context/LanugageContext'
import { footerTranslations } from '../translations/footer'

const Footer = () => {
    const { lang } = useLanguage();
    const tr = footerTranslations[lang];

    return (
        <div>
            <footer>
                <div className="footer-content">
                    <div className="contact">
                        <h3 id="contact">{tr.contact}</h3>
                        <h4>
                            <i className="fas fa-phone-alt" />
                            <i className="fab fa-whatsapp" />
                            <i className="fab fa-viber" />
                            +385 98 294 555
                        </h4>
                        <h4>
                            <i className="fas fa-mail-bulk" />
                            slanoboatexcursions@gmail.com
                        </h4>
                    </div>
                    <div className="second-nav">
                        <h3>{tr.exploreMore}</h3>
                        <ul>
                            <li>
                                <Link to="/dubrovnik">{tr.dubrovnik}</Link>
                            </li>
                            <li>
                                <Link to="/elaphiti">{tr.elaphiti}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="social-media">
                        <h3>{tr.followUs}</h3>
                        <a href="https://www.facebook.com/SlanoBoatExcursions/">
                            <i className="fab fa-facebook" />
                        </a>
                        <a href="https://www.instagram.com/slano_boat_excursions/">
                            <i className="fab fa-instagram" />
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;